import {ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, Input} from '@angular/core';
import {UTMService} from '../../services/utm.service';
import {TrackerService} from '../../services/tracker.service';
import {TrackingService} from '../../services/tracking.service';

@Component({
    selector: 'app-end-chat',
    imports: [],
    templateUrl: './end-chat.component.html',
    styleUrl: './end-chat.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class EndChatComponent {
  @Input() experts: any[] = [];

  constructor(private utmService: UTMService,
              private trackerService: TrackerService,
              private trackingService: TrackingService) {
  }

  /** Lien vers la page dédiée Isabella (variable selon la langue). */
  get mailIsabellaUrl(): string {
    return this.withParams($localize`:Component 'end-chat', mail/Isabella card link href@@end_chat.mail.href:https://www.wengo.fr/landing/v0-isb/4417776-astrologie-tirages-de-cartes-guidance`, 'fin-isabella');
  }

  /** Lien vers le choix d'experts (variable selon la langue). */
  get expertsUrl(): string {
    return this.withParams($localize`:Component 'end-chat', experts card link href@@end_chat.experts.href:https://www.wengo.fr/voyance-astrologie-1270`, 'fin-liste');
  }

  /** La carte d'un expert recommande : sa landing, avec l'emplacement et la position de la carte. */
  psychicUrl(psychic: any, index: number): string {
    return this.withParams(psychic.url, `fin-cartes-${index + 1}`);
  }

  /** Ajoute à une URL de base les UTM de la campagne qui a amené le visiteur (ou celles de l'app), signées de
   *  l'emplacement du lien dans utm_term, et les trackers courants. */
  private withParams(base: string, placement: string): string {
    let url: URL;
    try {
      url = new URL(base);
    } catch {
      return base;
    }
    for (const [k, v] of Object.entries(this.utmService.appLinkUtm(placement))) {
      url.searchParams.set(k, v);
    }
    const trackerData = this.trackerService.getCurrentTrackerData(this.trackerService.getDefaultTrackerData());
    if (trackerData) {
      const trackers = this.trackerService.urlFormat(trackerData);
      for (const [k, v] of Object.entries(trackers)) {
        url.searchParams.set(k, v);
      }
    }
    return url.toString();
  }

  clickMail() {
    this.trackingService.gameEvent('ClickEndCardMail');
  }

  clickExperts() {
    this.trackingService.gameEvent('ClickEndCardExperts');
  }

  clickPsychic(psychic: any) {
    this.trackingService.gameEvent('ExpertClick', {expert: {id: psychic.id, title: psychic.title}});
  }

  formatSatisfaction(value: number | null | undefined): string {
    if (value === null || value === undefined) return '';
    return `${Math.round(value * 10) / 10}`.replace('.', ',');
  }

  formatCount(value: number | null | undefined): string {
    if (!value) return '';
    if (value >= 1000) return `${Math.round(value / 1000)}k`;
    return `${value}`;
  }
}
